export const PER_PAGE = 20;

export const RENDER_NEXT_PAGE = 'RENDER_NEXT_PAGE';
export const GO_TO_PAGE = 'GO_TO_PAGE';
export const SOCKET_FLIGHTS_RECEIVED = 'SOCKET_FLIGHTS_RECEIVED';
export const SOCKET_CARRIER_FILTERS_UPDATED = 'SOCKET_CARRIER_FILTERS_UPDATED';
export const SELECT_CARRIER_FILTER = 'SELECT_CARRIER_FILTER';
export const SET_SELECTED_URL_FILTERS = 'SET_SELECTED_URL_FILTERS';
export const TRANSFER_TIME_RECEIVED = 'TRANSFER_TIME_RECEIVED';
export const SELECT_TRANSFER_TIME_FILTER = 'SELECT_TRANSFER_TIME_FILTER';
export const SELECT_TRANSFER_TIME_FILTER_UPDATE = 'SELECT_TRANSFER_TIME_FILTER_UPDATE';
export const SOCKET_FILTER_RESPOND = 'SOCKET_FILTER_RESPOND';
export const FLIGHT_DURATIONS_BATCH_RECEIVED = 'FLIGHT_DURATIONS_BATCH_RECEIVED';
export const UPDATE_MOBISCROLL = 'UPDATE_MOBISCROLL';
export const FLIGHT_DURATION_CHANGE = 'FLIGHT_DURATION_CHANGE';
export const FLIGHT_DURATION_CHANGE_UPDATE = 'FLIGHT_DURATION_CHANGE_UPDATE';
export const FORWARD_TIME_CHANGE = 'FORWARD_TIME_CHANGE';
export const FORWARD_TIME_CHANGE_UPDATE = 'FORWARD_TIME_CHANGE_UPDATE';
export const FORWARD_TIME_TYPE_CHANGE = 'FORWARD_TIME_TYPE_CHANGE';
export const RETURN_TIME_CHANGE = 'RETURN_TIME_CHANGE';
export const RETURN_TIME_TYPE_CHANGE = 'RETURN_TIME_TYPE_CHANGE';
export const RETURN_TIME_CHANGE_UPDATE = 'RETURN_TIME_CHANGE_UPDATE';
export const STOPS_SELECT = 'STOPS_SELECT';
export const NO_NIGHT_TRANSFER_SELECT = 'NO_NIGHT_TRANSFER_SELECT';
export const ARRIVAL_AIRPORTS_BATCH_RECEIVED = 'ARRIVAL_AIRPORTS_BATCH_RECEIVED';
export const RETURN_AIRPORTS_BATCH_RECEIVED = 'RETURN_AIRPORTS_BATCH_RECEIVED';
export const ARRIVAL_AIRPORT_SELECTED = 'ARRIVAL_AIRPORT_SELECTED';
export const STOP_AIRPORT_SELECTED = 'STOP_AIRPORT_SELECTED';
export const RETURN_AIRPORT_SELECTED = 'RETURN_AIRPORT_SELECTED';
export const STOP_AIRPORTS_BATCH_RECEIVED = 'STOP_AIRPORTS_BATCH_RECEIVED';
export const BAGGAGE_BATCH_RECEIVED = 'BAGGAGE_BATCH_RECEIVED';
export const BAGGAGE_FILTER_SELECTED = 'BAGGAGE_FILTER_SELECTED';
export const STOPS_RECEIVED = 'STOPS_RECEIVED';
export const AIRLINES_FILTER_SHOW_MORE = 'AIRLINES_FILTER_SHOW_MORE';
export const AIRLINES_FILTER_SHOW_ALL = 'AIRLINES_FILTER_SHOW_ALL';
export const FLIGHTS_COUNT_UPDATED = 'FLIGHTS_COUNT_UPDATED';
export const FLIGHTS_IMPORT_END = 'FLIGHTS_IMPORT_END';
export const CHEAPEST_FLIGHT_UPDATE = 'CHEAPEST_FLIGHT_UPDATE';
export const RECOMMENDED_FLIGHT_UPDATE = 'RECOMMENDED_FLIGHT_UPDATE';
export const PARENT_FILTERS_CHANGED = 'PARENT_FILTERS_CHANGED';
export const TOGGLE_OVERLAY = 'TOGGLE_OVERLAY';
export const STOP_AIRPORTS_FILTER_SHOW_MORE = 'STOP_AIRPORTS_FILTER_SHOW_MORE';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const REFRESH_FLIGHTS = 'REFRESH_FLIGHTS';
export const RESET_ALL_FILTERS = 'RESET_ALL_FILTERS';

export const socketFlightsReceived = () => {
    return {
        type: SOCKET_FLIGHTS_RECEIVED
    }
};

export const renderNextPage = () => {
    return {
        type: RENDER_NEXT_PAGE,
        noDelay: true
    }
};

export const goToPage = page => {
    return {
        type: GO_TO_PAGE,
        page
    }
};

export const updateCarrierFilters = payload => {
    return {
        type: SOCKET_CARRIER_FILTERS_UPDATED,
        payload
    }
};

export const transferTimeReceived = time => {
    return {
        type: TRANSFER_TIME_RECEIVED,
        time
    }
};

export const selectTransferTimeFilters = time => {
    return {
        type: SELECT_TRANSFER_TIME_FILTER,
        time
    }
};

export const selectTransferTimeFiltersUpdate = () => {
    return {
        type: SELECT_TRANSFER_TIME_FILTER_UPDATE,
    }
};

export const selectCarrierFilter = carrier => {
    return {
        type: SELECT_CARRIER_FILTER,
        carrier
    }
};

export const setSelectedUrlFilters = (name, payload) => {
    return {
        type: SET_SELECTED_URL_FILTERS,
        name,
        payload
    }
};

export const socketFlightsFiltered = payload => {
    return {
        type: SOCKET_FILTER_RESPOND,
        payload
    };
};

export const arrivalAirportsReceived = payload => {
    return {
        type: ARRIVAL_AIRPORTS_BATCH_RECEIVED,
        payload
    };
};

export const returnAirportsReceived = payload => {
    return {
        type: RETURN_AIRPORTS_BATCH_RECEIVED,
        payload
    };
};

export const stopAirportsReceived = payload => {
    return {
        type: STOP_AIRPORTS_BATCH_RECEIVED,
        payload
    };
};

export const baggageReceived = payload => {
    return {
        type: BAGGAGE_BATCH_RECEIVED,
        payload
    };
};

export const stopsReceived = maxStops => {
    return {
        type: STOPS_RECEIVED,
        maxStops
    };
};

export const baggageFilterSelect = payload => {
    return {
        type: BAGGAGE_FILTER_SELECTED,
        payload
    };
};

export const flightDurationsReceived = payload => {
    return {
        type: FLIGHT_DURATIONS_BATCH_RECEIVED,
        payload
    };
};

export const flightDurationChange = payload => {
    return {
        type: FLIGHT_DURATION_CHANGE,
        payload
    };
};

export const flightDurationChangeUpdate = () => {
    return {
        type: FLIGHT_DURATION_CHANGE_UPDATE
    };
};

export const forwardTimeChange = payload => {
    return {
        type: FORWARD_TIME_CHANGE,
        payload
    };
};

export const forwardTimeChangeUpdate = () => {
    return {
        type: FORWARD_TIME_CHANGE_UPDATE,
    };
};

export const forwardTimeTypeChange = payload => {
    return {
        type: FORWARD_TIME_TYPE_CHANGE,
        payload
    };
};

export const returnTimeChange = payload => {
    return {
        type: RETURN_TIME_CHANGE,
        payload
    };
};

export const returnTimeTypeChange = payload => {
    return {
        type: RETURN_TIME_TYPE_CHANGE,
        payload
    };
};

export const returnTimeChangeUpdate = () => {
    return {
        type: RETURN_TIME_CHANGE_UPDATE,
    };
};

export const stopSelect = stops => {
    return {
        type: STOPS_SELECT,
        stops
    };
};

export const noNightTransferSelect = noNightTransfer => {
    return {
        type: NO_NIGHT_TRANSFER_SELECT,
        noNightTransfer
    };
};

export const arrivalAirportSelected = airport => {
    return {
        type: ARRIVAL_AIRPORT_SELECTED,
        airport
    };
};

export const returnAirportSelected = airport => {
    return {
        type: RETURN_AIRPORT_SELECTED,
        airport
    };
};

export const stopAirportSelected = airport => {
    return {
        type: STOP_AIRPORT_SELECTED,
        airport
    };
};

export const airlinesFilterShowMore = () => {
    return {
        type: AIRLINES_FILTER_SHOW_MORE
    };
};

export const stopAirportsFilterShowMore = () => {
    return {
        type: STOP_AIRPORTS_FILTER_SHOW_MORE
    };
};

export const airlinesFilterShowAll = () => {
    return {
        type: AIRLINES_FILTER_SHOW_ALL
    };
};

export const flightsCountUpdated = payload => {
    return {
        type: FLIGHTS_COUNT_UPDATED,
        payload
    };
};

export const flightsImportEnd = (data) => {
    return {
        type: FLIGHTS_IMPORT_END,
        data
    };
};

export const cheapestFlightUpdate = data => {
    return {
        type: CHEAPEST_FLIGHT_UPDATE,
        data
    };
};

export const recommendedFlightUpdate = data => {
    return {
        type: RECOMMENDED_FLIGHT_UPDATE,
        data
    };
};

export const parentFiltersChanged = (search, filters, firstRequest) => {
    return {
        type: PARENT_FILTERS_CHANGED,
        search,
        filters,
        firstRequest
    };
};

export const toggleOverlay = toggle => {
    return {
        type: TOGGLE_OVERLAY,
        toggle
    };
};

export const clearFilter = filter => {
    return {
        type: CLEAR_FILTER,
        filter
    }
};

export const refreshFlights = () => {
    return {
        type: REFRESH_FLIGHTS
    }
};

export const updateMobiscroll = () => {
    return {
        type: UPDATE_MOBISCROLL
    }
};

export const resetAllFilters = () => {
    return {
        type: RESET_ALL_FILTERS
    }
};



// WEBPACK FOOTER //
// ./src/actions/FlightsActions.js